import React from 'react';

export const PLAN_TAGLINES: Record<string, string> = {
  starter: 'AI Secretary, 24/7.',
  pro: 'More usage, more power.',
  max: 'For the heaviest workloads.',
};

const STARTER_FEATURES: React.ReactNode[] = [
  '5k credits per month',
  'Chat from anywhere with WhatsApp',
  'Connect unlimited inboxes',
  'A dedicated secretary inbox',
  'Clean your inboxes & draft replies',
  'Handle your scheduling',
  'Book your trips',
  'Connect Granola & other tools',
];

export function getFeatureList(planName: string): {
  heading: string;
  features: React.ReactNode[];
} {
  const key = planName.toLowerCase();
  if (key === 'pro') {
    return {
      heading: 'Everything in Starter, with:',
      features: [
        '10k credits per month',
        'Plus 10% free extra credits (every month)',
      ],
    };
  }
  if (key === 'max') {
    return {
      heading: 'Everything in Pro, with:',
      features: [
        '20k credits per month',
        'Plus 20% free extra credits (every month)',
      ],
    };
  }
  return { heading: 'What you get:', features: STARTER_FEATURES };
}
